// React
import React from 'react';

type appType = {
    appTitle: string;
    description: string;
    language: string;
    token: string;
    // updateToken: Function;
};

export const appState: appType = {
    appTitle: 'ALD flex backoffice-ui',
    description: 'ALD flex backoffice-ui',
    language: 'de-DE',
    token: '',
    // updateToken: () => {},
};

export const AppContext = React.createContext(appState);

export const appConfig = {
    languages: ['en-GB', 'de-DE'],
};
